<template>
	<div class="agree-bg">
		<div class="about_us" style="min-height: 1000px;margin-top:20px;margin-bottom: 20px">
			<p class="about_us_title" style="">关于我们</p>

			<p class="about_us_content">
        厦门市思明区智慧生活百乘百软件开发服务部开发的智慧生活10000号网站提供工作、生活AI应用，为用户提供近在咫尺的桌面端AI，让办公变得更高效，让生活变得更简单。用户可以在网站上完成注册、应用的下载、服务的订购、订单管理等操作，网站根据会员订购的服务提供差异化的应用功能。			</p>

<!--			<p class="about_us_content">网站名称：智慧生活10000号</p>
			<p class="about_us_content">网站类型：创意设计图库网站</p>
			<p class="about_us_content">IPC备案号：黔ICP备08100081号</p>-->

<!--			<p class="about_us_title" style="">网站简介</p>
			<p class="about_us_content">
				智慧生活10000号于2023年7月上线，专注于优质实用的设计资源下载。包括广告设计、海报、PNG素材、摄影图、插画背景、PPT模板、视频、音频、简历、Excel表格等。除了作品创意与美感，智慧生活10000号更注重作品的实用性，深入研究每一类作品的使用人群，使用场景、受众、需要作品传递的信息，从文案、设计风格、创意、构图上真正符合用户的真实场景需求，做到下载即用，大大提高了创意设计者的办公效率。智慧生活10000号拥有近万设计师，一直持续输出高质量图片素材，近几年来，智慧生活10000号不忘初心服务客户，使用智慧生活10000号的创意设计者已达千万数量，得到了各大设计师和企业人员的青睐，隐隐要成为设计行业的领头羊。
			</p>

			<p class="about_us_title" style="">素材分类</p>
			<p class="about_us_content">智慧生活10000号素材包括：设计模板、图片素材、PPT模板、视频素材、办公文档、小报模板、表格模板、音效配乐、字体库</p>
			<p class="about_us_content">
				广告设计：海报，易拉宝，展板，宣传单，宣传栏，画册，邀请函，优惠券，贺卡，文化墙，标语，制度，名片，舞台背景，广告牌，证书，明信片，菜单，折页，封面，节目单，门头，美陈，拱门，展架等</p>
			<p class="about_us_content">电商设计：主图，直通车，详情页，PC端首页，移动端首页，钻展，优惠券，促销标签，店招，店铺公告等</p>
			<p class="about_us_content">图片素材：PNG素材，背景素材，矢量素材，插画，元素，艺术字，UI设计等</p>
			<p class="about_us_content">视频素材：AE模板，会声会影，PR模板，视频背景，实拍短片，音效配乐</p>
			<p class="about_us_content">办公文档：工作汇报，毕业答辩，企业介绍，总结计划，教学课件，求职简历等PPT/WORD模板</p>-->

			<p class="about_us_title" style="">网站文化</p>
			<p class="about_us_content">网站定位：提供近在咫尺的桌面端AI</p>
			<p class="about_us_content">网站愿景：让办公变得更高效，让生活变得更简单</p>

			<p class="lianxi">联系方式：</p>
			<p class="kefu" style="font-size: 14px;"><span>客服QQ：</span>{{getQQService}}</p>
			<p class="kefu" style="font-size: 14px;"><span>客服邮箱：</span>{{getQQService}}@qq.com</p>


      <p class="about_us_title">联系地址：</p>
      <p class="about_us_content">厦门市思明区湖滨南路 36 号之四 102 室</p>
    </div>
	</div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
  import { getConfigQQ } from '@/api/config'
  export default {

    computed: {
      ...mapGetters(["getQQService"]),
    },
    created() {
      this.getQQKefu()
    },
    methods:{
      ...mapActions(["setQQService"]),
      getQQKefu() {
        getConfigQQ("qq").then(res => {
          this.setQQService(res.data.content);
        })
      }
    },

  };
</script>
<style scoped>
	.agree-bg {
		width: 100%;
		background: #F4F4F4;
		overflow: hidden;
		display: flex;
		justify-content: center;
	}

	.about_us {
		height: 325px;
		width: 995px;
		background: #fff;
		float: left;
		margin-left: 20px;
	}

	.about_us_title {
		font-size: 16px;
		color: #4A4A4A;
		margin-top: 45px;
		margin-bottom: 20px;
		margin-left: 25px;
		font-weight: bold;
	}

	.about_us_content {
		font-size: 14px;
		margin-left: 25px;
		color: #888888;
		margin-right: 25px;
	}

	.lianxi {
		color: #4A4A4A;
		margin: 30px 0px 30px 25px;
		font-size: 14px;
		font-weight: bold;
	}

	.address {
		margin-bottom: 20px;
	}

	.address,
	.kefu {
		margin-left: 25px;
		color: #888888;
	}
</style>
